// @flow

import * as React from 'react';
import { Column, Row } from '../Layout';

export default class ItemContainer extends React.Component<*> {
  render() {
    return (
      <Row>
        <Column medium={8} offsetMedium={2} large={6} offsetLarge={3}>
          {this.props.children}
        </Column>
      </Row>
    );
  }
}
